import api from 'src/services/api'
import {CameraHasObjects} from 'src/services/api/endpoints/ObjectEndpoint'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export type RowType = {
  id: number
  typeObject: string
  barrierType: string
  barrier: string
  active: boolean
  description?: string
  confidence: string
  drive: string
  self: CameraHasObjects
}

export enum TranslateBarrierType {
  'interest-area' = 'Área de interesse',
  'line-crossing' = 'Cruzamento de linha',
  'speed' = 'Linhas de Velocidade',
}

export function objectDetectionRow(objects: CameraHasObjects[]): Array<RowType> {
  const rowObjects = objects.map((it) => {
    let objectLabel = it.objectType.label

    if (it.isObjectCounting) objectLabel = `Relatório de Contagem - ${it.objectType.label}`
    if (it.isObjectPermanency) objectLabel = `Tempo de Permanência - ${it.objectType.label}`
    return {
      id: it.id,
      typeObject: objectLabel,
      barrierType: TranslateBarrierType[it.type],
      barrier: it.interestArea?.name ?? '-',
      active: it.isActive,
      confidence: `${(Number(it.confidence) * 100).toFixed()}%`,
      drive: it.actions.length > 0 ? 'Sim' : 'Não',
      self: it,
    }
  })

  return rowObjects
}

export async function deleteObject(self: CameraHasObjects, loadObjects: () => void, enqueueSnackbar: any) {
  try {
    await api.object.deleteAllTypesObject(self.id)
    enqueueSnackbar('Objeto excluído com sucesso', {
      variant: 'success',
    })
    loadObjects()
  } catch (error) {
    handleErrorWithSnackbar(enqueueSnackbar, error, 'Falha ao excluir objetos')
  }
}

export async function updateIsActive(checked: boolean, row: RowType, enqueueSnackbar: any, getLoadObjetcs: () => void) {
  try {
    await api.object.updateAllTypesObjects({id: row.id, isActive: checked})
    enqueueSnackbar('Objeto atualizado com sucesso', {
      variant: 'success',
    })
    getLoadObjetcs()
  } catch (error) {
    handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao atualizar objeto')
  }
}
